import { PromotionRepository, CreatePromotionInput } from '../../domain/repositories/promotion.repository';
import { PromotionEntity } from '../../domain/entities/promotion.entity';

export class CreatePromotionUseCase {
  constructor(private readonly promotionRepository: PromotionRepository) {}

  async execute(input: CreatePromotionInput): Promise<PromotionEntity> {
    return this.promotionRepository.createPromotion(input);
  }
}
